var _desc, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "40px",
    viewBox: "0 0 45 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_recieved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-A-Message-V5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25-Control-Groups",
    transform: "translate(-96.000000, -495.000000)",
    fill: "#495462",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.492623,510 L138.492623,497.5 C138.492623,496.117188 137.375629,495 135.993057,495 C130.915813,499.375 122.401666,505 112.247179,505 L99.7493491,505 C97.6793959,505 96,506.679688 96,508.75 L96,516.25 C96,518.320312 97.6793959,520 99.7493491,520 L101.061621,520 C100.647631,524.578125 102.233293,528.359375 103.319042,531.84375 C103.436209,532.234375 103.654921,532.585938 103.943933,532.875 C105.295261,534.226562 107.154313,535 109.04461,535 C111.528554,535 113.801597,533.671875 114.942024,531.273438 C115.488804,530.125 115.090436,528.75 114.012498,528.078125 C111.833189,526.71875 111.512932,526.320312 111.919111,525.617188 C112.45808,524.671875 112.325291,523.484375 111.591043,522.679688 C111.177053,522.226562 111.489498,520.539062 112.450269,520 C122.518834,520.070312 130.954869,525.65625 136.000868,530 C137.38344,530 138.500434,528.882812 138.500434,527.5 L138.500434,515 C139.883006,515 141,513.882812 141,512.5 C141,511.117188 139.875195,510 138.492623,510 Z M112.692415,530.195312 C111.333275,533.0625 107.732338,533.117188 105.709252,531.101562 C104.631314,527.625 103.139386,524.132812 103.57681,520 L109.333623,520 C108.685298,521.5 108.739976,523.289062 109.747613,524.375 C108.193196,527.085938 110.372505,528.75 112.692415,530.195312 Z M98.499566,516.25 L98.499566,508.75 C98.499566,508.0625 99.0619684,507.5 99.7493491,507.5 L113.496962,507.5 L113.496962,517.5 L99.7493491,517.5 C99.0619684,517.5 98.499566,516.9375 98.499566,516.25 Z M135.993057,526.75 C133.134178,524.476562 130.158132,522.578125 127.111786,521.109375 C123.417115,519.320312 119.691199,518.1875 115.996528,517.734375 L115.996528,507.265625 C119.691199,506.804688 123.417115,505.679688 127.111786,503.890625 C130.150321,502.414062 133.134178,500.523438 135.993057,498.25 L135.993057,526.75 Z",
    id: "ic_recieved"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.e81b7ce1b4a9f294f4d3a7834ecec857.svg";
export { ForwardRef as ReactComponent };